import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';

// Maps the active app language onto the dayjs locale the MUI X pickers use, so
// the calendar and the date format follow the user's language. English is the
// dayjs built-in default and needs no extra import.
function dayjsLocale(language: string): string {
    /* v8 ignore next */
    return language.split('-')[0] || 'en';
}

export function DateLocalizationProvider({ children }: { children: ReactNode }): ReactElement {
    const { i18n } = useTranslation();
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjsLocale(i18n.language)}>
            {children}
        </LocalizationProvider>
    );
}
